<template>
    <div class="editable-cell">
      <div v-if="editable" class="editable-cell-input-wrapper">
        <a-select
          :value="currentValue"
          @change="handleChange"
          @search="handleSearch"
          @blur="check"
          :options="selectOptions"
          :notFoundContent="null"
          style="width: 100%">
          <a-icon
            slot="notFoundContent"
            type="plus-circle"
            @click="handleAddCustom"
          />
        </a-select>
        <a-icon type="check" class="editable-cell-icon-check" @click="check" />
      </div>
      <div v-else class="editable-cell-text-wrapper">
        {{ displayValue || '请选择' }}
        <a-icon type="edit" class="editable-cell-icon" @click="edit" />
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "EditableSelectCell",
    props: {
      value: {
        type: [String, Number],
        default: ''
      },
      options: {
        type: Array,
        default: () => []
      },
      allowCustom: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        editable: false,
        selectOptions: this.options,
        currentValue: this.value
      }
    },
    computed: {
      displayValue() {
        const option = this.selectOptions.find(opt => opt.value === this.currentValue)
        return option ? option.label : this.currentValue
      }
    },
    methods: {
      handleChange(value) {
        this.currentValue = value
        this.$emit('input', value)
      },
      check() {
        this.editable = false
        this.$emit('change', this.currentValue)
      },
      edit() {
        this.editable = true
      },
      handleSearch(val) {
        if (this.allowCustom) {
          this.selectOptions = [
            ...this.options,
            { label: val, value: val }
          ].filter((v, i, a) => a.findIndex(t => t.value === v.value) === i)
        }
      },
      handleAddCustom() {
        if (this.currentValue && !this.selectOptions.some(opt => opt.value === this.currentValue)) {
          this.selectOptions.push({ label: this.currentValue, value: this.currentValue })
          this.handleChange(this.currentValue)
        }
      }
    },
    watch: {
      value(newVal) {
        this.currentValue = newVal
      },
      options(newOpts) {
        this.selectOptions = newOpts
      }
    }
  }
  </script>
  
  <style scoped>
  .editable-cell {
    position: relative;
    display: inline-flex;
    align-items: center;
  }
  
  .editable-cell-input-wrapper,
  .editable-cell-text-wrapper {
    padding-right: 12px;
  }
  
  .editable-cell-text-wrapper {
    padding: 5px 24px 5px 5px;
    cursor: pointer;
  }
  
  .editable-cell-icon{
    position: absolute;
    left: 40px;
    width: 20px;
    cursor: pointer;
  }

  .editable-cell-icon-check {
    position: absolute;
    left: 95px;
    width: 20px;
    cursor: pointer;
  }

  ::v-deep .ant-select-selection--single {
    position: relative;
    height: 32px;
    cursor: pointer;
    width: 90px;
  }

  
  
  .editable-cell-icon {
    line-height: 32px;
    opacity: 0.6;
    transition: opacity 0.3s;
  }
  
  .editable-cell-icon:hover {
    opacity: 1;
  }
  
  .ant-select-selection-item {
    padding-right: 32px !important;
  }
  </style>